<script setup>
import { PlusOutlined } from "@ant-design/icons-vue";
import { getRequest, postRequest, putRequest } from "@/utils/request.js";
import { message } from "ant-design-vue";
import { reactive, ref, unref } from "vue";

const emit = defineEmits(["ok"]);
const title = ref("");
const open = ref(false);
const confirmLoading = ref(false);
const imageUrl = ref("");
const formModel = ref({});
const formRef = ref();
const treeList = ref([]);
const rules = reactive({
  title: [
    {
      required: true,
      message: "请输入分类名称",
      trigger: "blur",
    },
  ],
  options: [
    {
      required: true,
      message: "请添加至少一个选项",
      trigger: "blur",
      validator: () => {
        if (formModel.value.options.length > 0) {
          return Promise.resolve();
        }
        return Promise.reject();
      },
    },
    {
      required: true,
      message: "请填写选项名称",
      trigger: "blur",
      validator: () => {
        if (formModel.value.options.length > 0) {
          const hasEmptyOption = formModel.value.options.some(
            (option) => !option.name,
          );
          if (hasEmptyOption) {
            return Promise.reject();
          } else {
            return Promise.resolve();
          }
        }
        return Promise.reject();
      },
    },
  ],
  categoryId: [
    {
      required: true,
      message: "请输入所属分类",
      trigger: "blur",
    },
  ],
});

const handleAdd = (record) => {
  handleEdit(record);
};

const handleEdit = (record) => {
  formModel.value = Object.assign({}, { ...record });
  loadData();
  loadCategory();
  open.value = true;
  formModel.value.selectedJobTypeIds = formModel.value.jobTypeIds.split(",");
};

const handleClose = () => {
  open.value = false;
  formRef.value.resetFields();
  imageUrl.value = "";
};

const handleConfirm = () => {
  formRef.value.validate().then(async () => {
    const unrefFormModel = unref(formModel);
    let request;
    if (unrefFormModel.id) {
      request = putRequest;
    } else {
      request = postRequest;
    }
    request("/jobTypeKeyword", unrefFormModel).then((response) => {
      if (response.success) {
        message.success("保存成功");
        emit("ok");
        handleClose();
      } else {
        message.error("保存失败。" + response.message);
      }
    });
  });
};

const loadData = () => {
  getRequest("/jobType").then((response) => {
    if (response.success) {
      response.data.forEach((bigCategory) => {
        bigCategory.checkable = false;
        bigCategory.children.forEach((smallCategory) => {
          smallCategory.checkable = false;
        });
      });
      treeList.value = response.data;
    }
  });
};

const handleAddOption = () => {
  if (!formModel.value.options) {
    formModel.value.options = [];
  }
  formModel.value.options.push({ editable: true });
};

const handleCloseOption = (index) => {
  formModel.value.options.splice(index, 1);
};

const handleEditOption = (option) => {
  option.editable = true;
};

const handleCancelOption = (option) => {
  option.editable = false;
};

const category = ref([]);
const loadCategory = () => {
  getRequest("/jobTypeKeywordCategory/tree").then((response) => {
    if (response.success) {
      category.value = response.data;
    }
  });
};

defineExpose({
  handleAdd,
  handleEdit,
  handleClose,
  title,
});
</script>

<template>
  <a-modal
    width="800px"
    :open="open"
    :title="title"
    :confirm-loading="confirmLoading"
    @cancel="handleClose"
    @ok="handleConfirm"
  >
    <a-form
      ref="formRef"
      :labelCol="{ span: 3 }"
      :wrapperCol="{ span: 24 }"
      :model="formModel"
      :rules="rules"
    >
      <a-form-item label="标题" name="title">
        <a-input v-model:value="formModel.title" placeholder="请输入标题" />
      </a-form-item>
      <a-form-item label="选项" name="options">
        <template
          v-for="(option, index) in formModel.options"
          :key="option.id || index"
        >
          <a-tag
            v-if="!option.editable"
            :closable="true"
            @click="handleEditOption(option)"
            @close="handleCloseOption(index)"
          >
            {{ option.name }}
          </a-tag>
          <a-input
            v-else
            v-model:value="option.name"
            @blur="handleCancelOption(option)"
          >
          </a-input>
        </template>

        <a-tag
          style="background: #fff; border-style: dashed"
          @click="handleAddOption"
        >
          <plus-outlined />
          添加
        </a-tag>
      </a-form-item>
      <a-form-item label="单选/多选" name="multipleChoice">
        <a-switch
          v-model:checked="formModel.multipleChoice"
          checked-children="多选"
          un-checked-children="单选"
        />
      </a-form-item>
      <a-form-item label="排序" name="sort">
        <a-input-number
          v-model:value="formModel.sort"
          placeholder="请输入排序"
          style="width: 100%"
        />
      </a-form-item>
      <a-form-item label="所属分类" name="categoryId">
        <a-tree-select
          v-if="category.length"
          v-model:value="formModel.categoryId"
          defaultExpandAll
          :show-line="true"
          :show-icon="false"
          blockNode
          :tree-data="category"
          :field-names="{
            children: 'children',
            label: 'name',
            value: 'id',
          }"
          placeholder="请选择所属分类"
        >
        </a-tree-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<style scoped lang="scss"></style>
